import React from "react";

const Policy = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                <h4 className="title_text text-dark mb-3">TopCoin UK Ltd - Privacy Policy</h4>
                <p className="text-dark fw-semibold opacity-50 mb-0">Effective Date: 6 September 2026</p>
                <p className="text-dark fw-semibold opacity-50 mb-3">Company Registration No.: 16483297 | info@topcoinuk.com</p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">1. Introduction</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK Ltd ("TopCoin UK", "we", "us" or "our") respects your privacy and is committed to protecting your personal information.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  This Privacy Policy explains how we collect, use, store, share and protect personal information when you use the TopCoin UK website, platform, account services, TopCoin Wallet and, where applicable, the Captain TC Rewards Programme and associated wallets.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK Ltd is responsible for determining how and why personal information covered by this Privacy Policy is processed.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">2. Personal Information We May Collect</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Depending on how you use TopCoin UK, we may collect and process information including:
                </p>
                <ul className="info_description text-dark opacity-50 mb-2">
                  <li><strong>Account information</strong> - such as your name, email address, account details and login-related information.</li>
                  <li><strong>Wallet information</strong> - including Wallet IDs, TopCoin activity, Captain TC Rewards TopCoin activity and Captain TC Gold Card registrations where applicable.</li>
                  <li><strong>Rewards information</strong> - including Captain TC Rewards Card details, card level, reward progress, qualifying rewards earned, reward claims and reward history.</li>
                  <li><strong>Transaction and qualifying-purchase information</strong> - information required to determine whether a purchase, transaction or promotion qualifies for TopCoin or Captain TC rewards.</li>
                  <li><strong>Technical information</strong> - such as IP address, browser or device information, login activity and security information.</li>
                  <li><strong>Cookie and analytics information</strong> - where applicable and subject to your choices and applicable law.</li>
                  <li><strong>Communications</strong> - information you provide when contacting TopCoin UK for customer support or other enquiries.</li>
                  <li><strong>Purchase and payment-related information</strong> - where you purchase a product or Captain TC Rewards Card directly through TopCoin UK, we may process information necessary to administer the purchase. Payment information may be processed by an authorised third-party payment provider rather than stored directly by TopCoin UK.</li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-0">
                  We do not intentionally request special-category personal information unless there is a lawful and necessary reason to do so.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">3. How We Use Personal Information</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  We may use personal information to:
                </p>
                <ul className="info_description text-dark opacity-50 mb-0">
                  <li>Create and administer TopCoin UK accounts;</li>
                  <li>Operate the TopCoin Wallet;</li>
                  <li>Operate the Captain TC Rewards Wallet and Captain TC Gold Wallet where applicable;</li>
                  <li>Register and administer Captain TC Rewards Cards and Captain TC Gold Cards;</li>
                  <li>Record TopCoin and Captain TC Rewards TopCoin;</li>
                  <li>Verify qualifying transactions and promotions;</li>
                  <li>Calculate, display and fulfil qualifying rewards;</li>
                  <li>Process purchases made directly through TopCoin UK where applicable;</li>
                  <li>Provide customer service and respond to enquiries;</li>
                  <li>Prevent and investigate fraud, misuse and unauthorised activity;</li>
                  <li>Maintain the security and operation of our platform;</li>
                  <li>Improve our website and Services;</li>
                  <li>Meet accounting, tax, regulatory and legal obligations; and</li>
                  <li>Establish, exercise or defend legal rights where necessary.</li>
                </ul>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">4. Our Lawful Bases for Processing</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Under UK data-protection law, TopCoin UK must have a lawful basis for processing personal information.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Depending on the circumstances, we may rely on:
                </p>
                <ul className="info_description text-dark opacity-50 mb-2">
                  <li><strong>Contract</strong> - where processing is necessary to provide an account, wallet, reward or other service requested by you.</li>
                  <li><strong>Legitimate interests</strong> - where processing is reasonably necessary to operate, secure and improve TopCoin UK, administer rewards, prevent fraud or protect our business and customers, provided those interests are not overridden by your rights.</li>
                  <li><strong>Legal obligation</strong> - where processing is required to comply with applicable law.</li>
                  <li><strong>Consent</strong> - where consent is required, including for certain marketing communications or non-essential cookies.</li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where processing is based on consent, you may withdraw that consent at any time.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">5. TopCoin and Wallet Data</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may maintain records associated with your TopCoin UK account and applicable wallets.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  This may include information concerning TopCoin, Captain TC Rewards TopCoin, Captain TC Rewards Cards, Captain TC Gold Cards, qualifying transactions and rewards.
                </p>
                <p className="info_description text-dark opacity-50 fw-bold mb-2">
                  Wallet identifiers and transaction records may constitute personal information where they can be linked to an identifiable customer or account.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  We process this information to operate the TopCoin UK and Captain TC loyalty and rewards systems, verify eligibility, maintain accurate records and prevent fraud or misuse.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">6. Captain TC Rewards Programme</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where you participate in the Captain TC Rewards Programme, we may process information necessary to administer your participation.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  This may include your Captain TC Rewards Card and card level; Captain TC Rewards TopCoin; Captain TC Rewards Wallet information; reward stages and rewards earned; Captain TC Gold Cards; unique card or serial-number registration; Captain TC Gold Wallet information; and reward claims and fulfilment information.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  This information may be linked to your TopCoin UK account so that we can administer and verify your rewards.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">7. Participating Companies, Shops and Retailers</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where you participate in qualifying promotions involving participating companies, shops or retailers, TopCoin UK may receive information necessary to verify that a qualifying transaction or promotional activity has taken place.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The information received will depend on the applicable promotion and technical arrangement.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Participating businesses may also process your personal information independently in connection with purchases you make from them. Their own privacy policies will apply to information they process for their own purposes.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">8. Third-Party Service Providers</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may use trusted third-party service providers to help operate its business and Services.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  These may include providers of website hosting and infrastructure; email and communications; analytics; security and fraud prevention; payment processing; affiliate or transaction tracking; customer support; and gift cards, vouchers and reward fulfilment.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where third parties process personal information on our behalf, we require appropriate data-protection arrangements where applicable.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Some third parties may process your information as independent controllers under their own privacy policies.
                </p>
                <p className="info_description text-dark opacity-50 fw-bold mb-0">
                  TopCoin UK does not sell your personal information.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">9. International Transfers</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Some service providers may process personal information outside the United Kingdom.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where personal information is transferred internationally, TopCoin UK will take appropriate steps required by applicable data-protection law to protect the information, including using recognised safeguards where required.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">10. Cookies</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may use cookies and similar technologies.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  <strong>Essential cookies</strong> may be used where necessary for website operation, account login, security and other essential functionality.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Subject to applicable requirements and your choices, <strong>non-essential cookies</strong> may be used for analytics, performance, advertising or other purposes.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where consent is legally required for non-essential cookies, those cookies will not be used until the required consent has been obtained.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Further information should be provided through the TopCoin UK cookie notice or cookie settings where applicable.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">11. Data Security</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK takes appropriate technical and organisational measures designed to protect personal information against unauthorised access, loss, misuse, alteration or disclosure.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Security measures may include access controls, appropriate encryption, secure systems, monitoring and other technical and organisational safeguards.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  No internet-based system can be guaranteed to be completely secure, but TopCoin UK will take reasonable and appropriate steps to protect personal information.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">12. Data Retention</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK retains personal information only for as long as reasonably necessary for the purposes for which it was collected, including providing our Services, administering accounts and rewards, resolving disputes, preventing fraud and satisfying accounting, tax, regulatory and legal requirements.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Different categories of personal information may therefore be retained for different periods.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  When personal information is no longer required, we will delete, anonymise or otherwise securely dispose of it where appropriate, subject to applicable legal requirements.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">13. Marketing Communications</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where permitted by law, TopCoin UK may send customers information about TopCoin UK, Captain TC, participating promotions and rewards.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where consent is required, we will obtain consent before sending such marketing.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  You may unsubscribe from marketing communications at any time using the unsubscribe option provided in the communication or by contacting TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Unsubscribing from marketing does not prevent us from sending necessary service or account communications.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">14. Your Data Protection Rights</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Depending on the circumstances, under UK data-protection law you may have rights including the right to:
                </p>
                <ul className="info_description text-dark opacity-50 mb-2">
                  <li>Request access to your personal information;</li>
                  <li>Request correction of inaccurate or incomplete information;</li>
                  <li>Request deletion of personal information in certain circumstances;</li>
                  <li>Request restriction of processing in certain circumstances;</li>
                  <li>Object to certain processing;</li>
                  <li>Request data portability where applicable;</li>
                  <li>Withdraw consent where processing is based on consent; and</li>
                  <li>Raise concerns about how your personal information is being processed.</li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-2">
                  These rights are subject to applicable legal conditions and exemptions.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  To exercise your rights, contact: <strong>info@topcoinuk.com</strong>
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may need to verify your identity before processing certain requests.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">15. Complaints</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  If you have concerns about how TopCoin UK handles your personal information, please contact us first at <strong>info@topcoinuk.com</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  You also have the right to make a complaint to the <strong>Information Commissioner's Office (ICO)</strong>, the UK's data-protection regulator.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">16. Children's Privacy</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK accounts and the Captain TC Rewards Programme are intended for customers aged <strong>18 or over</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  We do not knowingly provide these account-based Services to children under 18.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">17. Changes to This Privacy Policy</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may update this Privacy Policy from time to time to reflect changes to our Services, business practices or legal requirements.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The latest version will be published on the TopCoin UK website with its effective or updated date.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where required by law, we will provide appropriate notice of material changes.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">18. Contact Us</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  For questions about this Privacy Policy, your personal information or your data-protection rights, contact:
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  <strong>TopCoin UK Ltd</strong><br />
                  Company Registration No.: 16483297<br />
                  Email: <strong>info@topcoinuk.com</strong>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Policy;
